export const getEnabledEurozoneEnabledCountries = (
  eurozoneEnabledProperties
) => {
  const set = new Set();
  eurozoneEnabledProperties?.enabledCountries?.split(",").forEach((country) => {
    const trimmedCountry = country?.trim();
    if(trimmedCountry) {
      set.add(trimmedCountry);
    }
  });

  return set;
};
